import Wrapper from "../../../layout/Wrapper";
import CustomerManageComponent from "../../../screens/callcenters/customers/manage";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Customer Management",
	description: "",
};

export default function CustomerManage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<CustomerManageComponent />
		</Wrapper>
	);
}